module.exports = __webpack_public_path__ + "img/afb1c6b.png";